import axios from 'axios'
import { stringify } from 'query-string'
import Config from '../../config'

/* ------------- Types ------------- */
export interface GetTokenResponse {
  access_token: string
  expires_in: number
  refresh_expires_in: number
  refresh_token: string
}

/* ------------- Api ------------- */
const urlencodedHeaders = {
  'Content-Type': 'application/x-www-form-urlencoded',
}

export const getTokenByPasswordApi = (username: string, password: string) =>
  axios.post<GetTokenResponse>(
    `${Config.KEYCLOAK_DOMAIN}auth/realms/dop/protocol/openid-connect/token`,
    stringify({
      grant_type: 'password',
      client_id: Config.KEYCLOAK_CLIENT_ID,
      scope: '',
      username,
      password,
    }),
    { headers: urlencodedHeaders }
  )

export const getTokenByTid = (tid: string) =>
  axios.post<GetTokenResponse>(`https://${Config.ENVIRONMENT}-anonymous-gateway.dopapp.pl/verification/action-token`, {
    tid,
  })

export const getTokenByActionToken = async (actionToken: string) =>
  axios.post<GetTokenResponse>(
    `${Config.KEYCLOAK_DOMAIN}auth/realms/dop/protocol/openid-connect/token`,
    stringify({
      client_id: Config.KEYCLOAK_CLIENT_ID,
      grant_type: 'urn:ietf:params:oauth:grant-type:token-exchange',
      subject_token_type: 'urn:ietf:params:oauth:token-type:jwt',
      subject_token: actionToken,
    })
  )

export const getTokenByAuthProviderApi = async (code: string) =>
  axios.post<GetTokenResponse>(
    `${Config.KEYCLOAK_DOMAIN}auth/realms/dop/protocol/openid-connect/token`,
    stringify({
      grant_type: 'authorization_code',
      client_id: Config.KEYCLOAK_CLIENT_ID,
      redirect_uri: `${Config.HOST}/apple-preview?type=authentication`,
      scope: '',
      code,
    }),
    { headers: urlencodedHeaders }
  )
